import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckIcon, ChevronDownIcon, GiftIcon, HomeIcon, RulerIcon, CalculatorIcon, ClipboardCheckIcon } from 'lucide-react';
const bonuses = [{
  num: '1',
  icon: HomeIcon,
  title: 'Plan de Ejercicios Domiciliarios',
  tagline: 'Una hoja profesional para entregar a tu paciente y que el tratamiento no se detenga al salir del consultorio',
  bullets: ['Espacio para ejercicios, series, repeticiones y frecuencia', 'Diseño limpio para imprimir y entregar en mano'],
  value: '$11.900 ARS'
}, {
  num: '2',
  icon: RulerIcon,
  title: 'Guía de Escalas de Evaluación Kinésica',
  tagline: 'Las escalas más usadas en un solo lugar, listas para consultar en cualquier momento',
  bullets: ['EVA, Daniels, Barthel, Tinetti y Borg', 'Referencia rápida para usar dentro de la consulta'],
  value: '$6.900 ARS'
}, {
  num: '3',
  icon: CalculatorIcon,
  title: 'Plantilla de Presupuesto y Honorarios',
  tagline: 'Presentá tu plan de tratamiento con precio y condiciones de forma clara y profesional',
  bullets: ['Cantidad de sesiones, valor y modalidad de pago', 'Con espacio para firma del paciente'],
  value: '$11.900 ARS'
}, {
  num: '4',
  icon: ClipboardCheckIcon,
  title: 'Checklist de Alta y Cierre de Tratamiento',
  tagline: 'Cerrá cada tratamiento con un documento formal que te protege y le da confianza al paciente',
  bullets: ['Verificación de objetivos cumplidos y recomendaciones finales', 'Firma de alta con fecha y observaciones'],
  value: '$8.900 ARS'
}];
export function Bonuses() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-14 md:py-24 bg-brand-accent" data-id="element-17">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-18">
        <div className="text-center mb-10 md:mb-14" data-id="element-19">
          <span className="inline-block text-white/90 font-bold text-xs uppercase tracking-wider mb-3" data-id="element-20">
            4 Bonos Estratégicos Incluidos
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-4" data-id="element-21">
            Bonos por tiempo limitado
          </h2>
          <div className="w-20 h-1 bg-white mx-auto rounded-full" data-id="element-22"></div>
          <p className="text-white/80 mt-4 text-sm md:text-base" data-id="element-23">
            Tocá cada bono para ver el contenido completo
          </p>
        </div>

        <div className="space-y-3" data-id="element-24">
          {bonuses.map((bonus, index) => {
          const isOpen = openIndex === index;
          const Icon = bonus.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.05
          }} className={`bg-white rounded-2xl border-2 overflow-hidden transition-all duration-300 ${isOpen ? 'border-brand-dark shadow-2xl' : 'border-transparent shadow-md hover:shadow-lg'}`} data-id="element-25">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full text-left p-4 md:p-5 flex items-center gap-3 md:gap-5 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-dark focus-visible:ring-offset-2 rounded-2xl" aria-expanded={isOpen} data-id="element-26">
                  {/* Icon badge with number */}
                  <div className={`flex-shrink-0 relative w-12 h-12 md:w-14 md:h-14 rounded-xl flex items-center justify-center transition-colors duration-300 ${isOpen ? 'bg-brand-dark' : 'bg-brand-accent'}`} data-id="element-27">
                    <Icon className={`w-5 h-5 md:w-6 md:h-6 transition-colors ${isOpen ? 'text-brand-accent' : 'text-white'}`} data-id="element-28" />
                    <span className={`absolute -top-1.5 -right-1.5 w-5 h-5 md:w-6 md:h-6 rounded-full flex items-center justify-center text-[10px] md:text-xs font-black border-2 border-white transition-colors ${isOpen ? 'bg-white text-brand-dark' : 'bg-brand-dark text-white'}`} data-id="element-29">
                      {bonus.num}
                    </span>
                  </div>

                  {/* Title */}
                  <div className="flex-grow min-w-0" data-id="element-30">
                    <div className="flex items-center gap-2 mb-0.5" data-id="element-31">
                      <span className="text-[10px] md:text-xs font-bold text-brand-accent uppercase tracking-wider" data-id="element-32">
                        Bono {bonus.num}
                      </span>
                      <span className="text-[10px] md:text-xs font-bold text-emerald-600 bg-emerald-50 px-1.5 py-0.5 rounded uppercase tracking-wide" data-id="element-33">
                        Gratis
                      </span>
                    </div>
                    <h3 className="text-sm md:text-lg font-bold text-slate-900 leading-snug" data-id="element-34">
                      {bonus.title}
                    </h3>
                  </div>

                  {/* Chevron */}
                  <motion.div animate={{
                rotate: isOpen ? 180 : 0
              }} transition={{
                duration: 0.3
              }} className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-colors ${isOpen ? 'bg-brand-dark text-white' : 'bg-slate-100 text-slate-500'}`} data-id="element-35">
                    <ChevronDownIcon className="w-4 h-4" data-id="element-36" />
                  </motion.div>
                </button>

                <AnimatePresence initial={false} data-id="element-37">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-38">
                      <div className="px-4 md:px-5 pb-5 md:pb-6 pl-[76px] md:pl-[100px]" data-id="element-39">
                        <p className="text-xs md:text-sm italic text-slate-500 mb-4 border-l-2 border-brand-accent pl-3" data-id="element-40">
                          "{bonus.tagline}"
                        </p>
                        <ul className="space-y-2.5 mb-5" data-id="element-41">
                          {bonus.bullets.map((bullet, i) => <motion.li key={i} initial={{
                      opacity: 0,
                      x: -10
                    }} animate={{
                      opacity: 1,
                      x: 0
                    }} transition={{
                      delay: i * 0.08
                    }} className="flex items-start gap-2.5" data-id="element-42">
                              <div className="flex-shrink-0 w-5 h-5 rounded-full bg-brand-accent/10 flex items-center justify-center mt-0.5" data-id="element-43">
                                <CheckIcon className="w-3 h-3 text-brand-accent stroke-[3]" data-id="element-44" />
                              </div>
                              <span className="text-slate-700 text-sm leading-relaxed" data-id="element-45">
                                {bullet}
                              </span>
                            </motion.li>)}
                        </ul>
                        <div className="flex items-center gap-3 text-xs md:text-sm font-bold pt-3 border-t border-slate-100" data-id="element-46">
                          <span className="text-slate-400 line-through" data-id="element-47">
                            Valor: {bonus.value}
                          </span>
                          <span className="text-emerald-600 bg-emerald-50 px-2 py-1 rounded" data-id="element-48">
                            HOY GRATIS
                          </span>
                        </div>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>

        {/* Total value pill */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="mt-8 text-center" data-id="element-49">
          <div className="inline-flex flex-wrap items-center justify-center gap-2 bg-brand-dark text-white rounded-2xl px-6 py-4 shadow-xl" data-id="element-50">
            <GiftIcon className="w-5 h-5 text-brand-accent" data-id="element-51" />
            <span className="font-bold text-sm md:text-base" data-id="element-52">
              Valor total:{' '}
              <span className="text-brand-accent line-through opacity-70" data-id="element-53">
                $39.600 ARS
              </span>
              <span className="ml-2 text-emerald-400" data-id="element-54">
                — Incluidos sin costo adicional
              </span>
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}